module.exports = __webpack_public_path__ + "img/2_141.8dffa3b7.png";